import axios from 'axios';
import ServerProperties from '../../config/server.js'

export default {
	ModelReadSite: function(params){
	//console.log(params)
		let urlRequest = ServerProperties.ATM_CLOUD.API+'Location/Sites/All/'
		axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken
		//console.log(urlRequest)
		if (params.action === 'find'){
			urlRequest = ServerProperties.ATM_CLOUD.API+'Location/Sites/?search='+params.self.query+'&fields='+params.self.state.filterField
		}
		axios.get(urlRequest, {})
		.then(function (response) {
			params.onsuccess(params, response);
		})
		.catch(function (error) {
      		console.log(error)
			params.onfailed(params, error);
	    });
	},
  	ReadSiteAsset: function(params){
	    let urlRequest = (params.data.url === undefined) ? (ServerProperties.ATM_CLOUD.API+'Asset/Info/?site='+params.selectedAlias +'&ordering=Name') : params.data.url
	    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken
	    axios.get(urlRequest)
	    .then(function (response) {
	      params.onsuccess(params, response);
	    })
	    .catch(function (error) {
	      console.log(error)
	      params.onfailed(params, error);
		});
	},
	ReadMasterSiteType: function(params){
		let urlRequest = ServerProperties.ATM_CLOUD.API+'Master/SiteTypes/'
		axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken
		axios.get(urlRequest, {})
		.then(function (response) {
			params.onsuccess(params, response);
		})
		.catch(function (error) {
			console.log(error)
		});
	},	
	ReadMasterSiteStatus: function(params){
		let urlRequest = ServerProperties.ATM_CLOUD.API+'Master/SitesStatus/'
		axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken
		axios.get(urlRequest, {})
		.then(function (response) {
			params.onsuccess(params, response);
		})
		.catch(function (error) {
			console.log(error)
		});
	}			
} 


// WEBPACK FOOTER //
// ./src/App/topmenu/job/model.js